import React, { useState, useEffect, useCallback } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector, useDispatch } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { khoaPagingAction, deleteKhoaAction, filterListKhoa, syncKhoaAction } from '@store/reducers/khoa';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { createUrlWithParam } from '../../utils/helper';
import { URI_INTERNAL } from '../../utils/pathLocations';
import { objectShowNumber, messageToast } from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { Dropdown } from 'react-bootstrap';


const Khoa = () => {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();

    const valueSearch = useSelector((state) => state.search.valueSearch);
    const totalKhoa = useSelector((state) => state.khoa.totalKhoa);
    const listKhoa = useSelector((state) => state.khoa.listKhoa);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    // Hàm gọi API (đặt lên trước để dùng trong effect parse URL)
    const fetchData = useCallback(
        async (Page, Size, Search) => {
            const model = { Keyword: Search, PageIndex: Page, PageSize: Size };
            await dispatch(khoaPagingAction(model));
            history.replace(createUrlWithParam(URI_INTERNAL.KHOA_PATH, { page: Page, size: Size, search: Search }));
        },
        [dispatch, history]
    );

    // Đồng bộ dữ liệu Khoa từ API
    const handleSync = async () => {
        try {
            console.log("Gọi API đồng bộ Khoa...");
            const resultAction = await dispatch(syncKhoaAction(null));
            console.log("ResultAction:", resultAction);

            if (syncKhoaAction.fulfilled.match(resultAction)) {
                toast.success("Đồng bộ thành công!");
                fetchData(page, pageSize, search); // reload danh sách Khoa
            } else {
                // nếu backend trả lỗi
                const errorMsg = resultAction.payload?.message || "Đồng bộ thất bại!";
                toast.error(errorMsg);
            }
        } catch (error) {
            console.error(error);
            toast.error("Đồng bộ thất bại!");
        }
    };



    // Lấy param từ URL
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const pageParam = parseInt(params.get('page') || 1, 10);
        const sizeParam = parseInt(params.get('size') || 20, 10);
        const searchParam = params.get('search') || '';

        if (pageParam !== page) setPage(pageParam);
        if (sizeParam !== pageSize) setPageSize(sizeParam);
        if (searchParam !== search) setSearch(searchParam);

        // call fetchData immediately with parsed params to load data on mount / when URL changes
        fetchData(pageParam, sizeParam, searchParam);
    }, [location.search, fetchData]);

    // Khi valueSearch thay đổi từ global state
    useEffect(() => {
        if (valueSearch && valueSearch !== search) {
            setSearch(valueSearch);
            fetchData(1, pageSize, valueSearch);
            setPage(1);
        }
    }, [valueSearch, pageSize, search, fetchData]);

    // Pagination
    const changePage = (number) => {
        setPage(number);
        fetchData(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        const newSize = parseInt(e.target.value, 10);
        setPageSize(newSize);
        fetchData(page, newSize, search);
    };

    // Delete
    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (!idWantDelete) return;
        try {
            const result = await dispatch(deleteKhoaAction(idWantDelete));
            if (result.payload.errors) {
                toast.error(result.payload.errors.content[0]);
            } else if (result.payload === 200) {
                await dispatch(filterListKhoa(idWantDelete));
                toast.success(messageToast.messageToastDeleteSuccess);
                fetchData(page, pageSize, search);
            }
        } catch (error) {
            toast.error(messageToast.messageToastTryCatch);
        }
        setOpenConfirmDeleteModal(false);
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Danh sách Khoa</h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-2">
                                <form className="form-inline">
                                    <label className="mr-2">Hiển thị :</label>
                                    <select className="form-control" value={pageSize} onChange={onChangeShowNumber}>
                                        {objectShowNumber.map((item, key) => (
                                            <option key={key} value={item.value}>{item.text}</option>
                                        ))}
                                    </select>
                                </form>
                                <div className="d-flex align-items-center">
                                    {/* Nút Đồng bộ dữ liệu */}
                                    <button
                                        type="button"
                                        className="btn btn-warning me-2" // me-2 = margin-right
                                        onClick={handleSync}
                                    >
                                        Đồng bộ dữ liệu
                                    </button>

                                    {/* Nút Thêm mới */}
                                    <NavLink className="nav-link-reject nav-link" to={URI_INTERNAL.KHOA_CREATE_PATH}>
                                        <button type="button" className="btn btn-info">
                                            Thêm mới
                                        </button>
                                    </NavLink>
                                </div>


                            </div>

                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>Mã Khoa</th>
                                        <th>Tên Khoa</th>
                                        <th>Chức năng</th>
                                    </tr>
                                </thead>
                                {listKhoa && listKhoa.length > 0 ? (
                                    <tbody>
                                        {listKhoa.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1 + (page - 1) * pageSize}</td>
                                                <td>{item.maKhoa}</td>
                                                <td>{item.name}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                                    <div className="d-flex justify-content-center">
                                                        <Dropdown align="end">
                                                            <Dropdown.Toggle
                                                                variant="outline-secondary"
                                                                size="sm"
                                                                id={`khoa-actions-${item.id}`}
                                                                className="d-inline-flex align-items-center justify-content-center"
                                                                style={{ minWidth: 92, whiteSpace: 'nowrap' }}
                                                            >
                                                                Thao tác
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu>
                                                                <Dropdown.Item
                                                                    as={NavLink}
                                                                    to={createUrlWithParam(URI_INTERNAL.KHOA_EDIT_PATH, { id: item.id })}
                                                                    exact
                                                                >
                                                                    Sửa
                                                                </Dropdown.Item>

                                                                <Dropdown.Divider />

                                                                <Dropdown.Item
                                                                    as="button"
                                                                    className="w-100 text-left text-danger"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        deleteAction(item.id, item.name);
                                                                    }}
                                                                >
                                                                    Xóa
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                ) : (
                                    <tbody>
                                        <tr className="txt-center">
                                            <td colSpan="4">Không có dữ liệu</td>
                                        </tr>
                                    </tbody>
                                )}
                            </Table>

                            <div className="dataTables_paginate paging_simple_numbers">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    innerClass="pagination pagination-sm no-margin pull-right"
                                    activePage={page}
                                    itemsCountPerPage={Number(pageSize)}
                                    totalItemsCount={totalKhoa}
                                    pageRangeDisplayed={5}
                                    onChange={changePage}
                                />
                            </div>

                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={acceptDelete}
                                handleCancel={cancelDelete}
                                content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Khoa;
